const PUBLIC_KEY = "9m0oB7mo4vTp48vm6";
const SERVICE_ID = "service_iyh5qnl";
const TEMPLATE_ID = "template_fd5pdye";

export { PUBLIC_KEY, SERVICE_ID, TEMPLATE_ID };
